<div class="obg-m-sitemap" *ngIf="sbRoute$ | async as sbRoute">
	<h1>Sportsbook Site Map</h1>

	<ng-container *ngFor="let sport of sports$ | async">
		<ul>
			<li><a [href]="sbRoute + '/' + sport.slug">{{ sport.name }}</a></li>
			<ng-container *ngFor="let region of sport.regions">
				<li>
					<a [href]="sbRoute + '/' + sport.slug + '/' + region.slug">{{ region.name }}</a>
					<ul>
						<ng-container *ngFor="let competition of region.competitions">
							<li>
								<a [href]="sbRoute + '/' + sport.slug + '/' + region.slug + '/' + competition.slug"
									>{{ competition.name }}</a
								>
								<ul>
									<ng-container *ngFor="let event of competition.events">
										<li>
											<a
												[href]="sbRoute + '/' + sport.slug + '/' + region.slug + '/' + competition.slug + '/' + event.slug"
												>{{ event.name }}</a
											>
										</li>
									</ng-container>
								</ul>
							</li>
						</ng-container>
					</ul>
				</li>
			</ng-container>
		</ul>
	</ng-container>
</div>
